import BpkBadge, {
  BADGE_TYPES,
} from '@skyscanner/backpack-web/bpk-component-badge';
import ThumbsUpIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/thumbs-up';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import STYLES from './DealBadge.module.scss';

const cls = cssModules(STYLES);

type Props = {
  text: string;
  icon?: React.ReactNode;
};

const DealBadge = ({ icon = <ThumbsUpIcon />, text }: Props) => (
  <BpkBadge type={BADGE_TYPES.brand} aria-hidden>
    {icon}
    <BpkText
      textStyle={TEXT_STYLES.footnote}
      className={cls('GreatPricesBadge__text')}
    >
      {text}
    </BpkText>
  </BpkBadge>
);

export default DealBadge;
